function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.2157 9.34662C10.1144 8.39211 10.6652 7.10624 10.6652 5.69173C10.6652 2.74662 8.27771 0.359131 5.3326 0.359131C2.38748 0.359131 0 2.74662 0 5.69173C0 7.98526 1.44793 9.94061 3.47957 10.6936L2.40051 11.3166C1.21259 12.0024 0.805576 13.5214 1.49142 14.7093C2.17727 15.8972 3.69626 16.3042 4.88419 15.6184L8.80646 13.3539C9.99438 12.668 10.4014 11.149 9.71555 9.96111C9.57893 9.72447 9.40924 9.51882 9.2157 9.34662Z",
  fill: "#38FBFD",
  fillOpacity: 1
});

function SvgGoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoji);
export default __webpack_public_path__ + "static/media/Goji.5d77cda8.svg";
export { ForwardRef as ReactComponent };